export function updateOpacity(swiper) {
    const slides = swiper.slides;
    const activeIndex = swiper.activeIndex;
    let visibleSlides = swiper.params.slidesPerView;

    if (visibleSlides === 'auto') {
        visibleSlides = 0;
        let totalWidth = 0;
        for (let i = activeIndex; i < slides.length; i++) {
            totalWidth += slides[i].clientWidth + swiper.params.spaceBetween;
            if (totalWidth > swiper.width) break;
            visibleSlides++;
        }
    }

    slides.forEach((slide, index) => {
        if (index >= activeIndex && index < activeIndex + visibleSlides) {
            slide.classList.remove('opacified');
        } else {
            slide.classList.add('opacified');
        }
    });

    // Assurer que le dernier élément visible n'est pas opacifié
    const lastVisibleIndex = activeIndex + visibleSlides - 1;
    if (lastVisibleIndex >= 0 && lastVisibleIndex < slides.length) {
        slides[lastVisibleIndex].classList.remove('opacified');
    }
}
